import React from 'react';
import './common.css';
import { PlayLogo } from '../../assets';

const DemoButton = ({
  link = '/demo',
  label = 'Get Demo',
  showPlayLogo = true,
  size = 'small',
  style = {},
  variant = 'primary',
  icon = null,
  className = '',
}) => {
  return (
    <a
      href={link}
      className={`btn ${className} demo-button-${size} demo-button demo-button-${variant} btn-rounded button-${size}`}
      style={style}
    >
      {label}
      {icon ? icon : showPlayLogo && <img src={PlayLogo} alt="" />}
    </a>
  );
};

export default DemoButton;
